import React from 'react';
import PropTypes from 'prop-types';
// import { noop } from 'mobx/lib/internal';
import styles from './styles.module.less';

const propTypes = {
  receivingInformation: PropTypes.shape({
    consigneeName: PropTypes.string,
    consigneeAddress: PropTypes.string,
    consigneeMobile: PropTypes.string,
  }),
  handleChangeAddress: PropTypes.func,
  phone: PropTypes.string,
};

const defaultProps = {
  receivingInformation: {},
  handleChangeAddress: () => {},
  phone: '',
};

/**
 * 地址
 * @param props
 * @returns {*}
 * @constructor consigneeAddress
 */
const Address = (props) => {
  const { receivingInformation, handleChangeAddress, phone } = props;
  // const [showPhone, setShowPhone] = useState(false);

  const scrollPosition = () => {
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
  };

  return (
    <div className={styles.itemContentBottom}>
      <div className={styles.addressItem}>
        <span className={styles.onlineLabel}>收货人姓名</span>
        <input
          value={receivingInformation.consigneeName}
          type="text"
          onBlur={scrollPosition}
          placeholder="收货人姓名"
          onChange={handleChangeAddress('consigneeName')}
        />
      </div>
      <div className={styles.addressItem}>
        <span className={styles.onlineLabel}>收货人地址</span>
        <input
          type="text"
          value={receivingInformation.consigneeAddress}
          onBlur={scrollPosition}
          placeholder="收货人地址"
          onChange={handleChangeAddress('consigneeAddress')}
        />
      </div>
      {/* <div className={styles.receiverClass} onClick={changePhoneShow}>
        修改收货人电话
      </div> */}
      <div className={styles.addressItem}>
        <span className={styles.onlineLabel}>收货人电话</span>
        <input
          type="text"
          value={
            receivingInformation.consigneeMobile === undefined
              ? phone
              : receivingInformation.consigneeMobile
          }
          onBlur={scrollPosition}
          maxLength={11}
          placeholder="收货人电话"
          onChange={handleChangeAddress('consigneeMobile')}
        />
      </div>
    </div>
  );
};

Address.propTypes = propTypes;
Address.defaultProps = defaultProps;

export default Address;
